<template>
  <div v-if="card.user" :style="$vuetify.breakpoint.xs ? '': 'background-color:#f0f5f7; height:100% !important;'" style="">

    <v-app-bar v-if="$vuetify.breakpoint.xs" flat color="sum" height="150" app
               style="border-bottom-right-radius: 25px; border-bottom-left-radius: 25px"
               class="hidden-sm-and-up bg-color">
      <img style="position: absolute; right: 40px; top: 0px; height: 100px;" :src="require('@/assets/trokut.png')"/>
      <a href="https://sum.ba" target="_blank">
        <img height="80" :src="require('@/assets/sum-white.svg')" style="border-radius: 0px;" class="mt-8"/>
      </a>
      <v-spacer></v-spacer>
      <v-row>
        <v-col cols="12" class="text-end">
<!--          <div class="white&#45;&#45;text ml-12 mr-3">-->
<!--            <v-icon size="26" color="white">mdi-flag-outline</v-icon>-->
<!--            HR-->
<!--          </div>-->
        </v-col>
        <v-col cols="12" class="text-end pt-1 pb-0">
          <div class="white--text ml-12 mr-3">
            <div style="text-transform:capitalize; font-size: 10px">
              {{ moment(today).format("dddd, D.M.YYYY.") }}
            </div>
            <div style="font-size: 18px">{{ moment(today).format("HH:mm:ss") }}</div>
          </div>
        </v-col>
      </v-row>
    </v-app-bar>
    <div class="mx-5 mt-5" style="display: flex" v-if="$vuetify.breakpoint.smAndDown">
      <img v-if="card.user" class="hidden-sm-and-up img-radius" :src="card.user.avatar_url"/>
      <div v-if="$vuetify.breakpoint.xs" class="ml-5">
        <div class="font-weight-medium font-title">{{ card.user.first_name + ' ' + card.user.last_name }}</div>
        <div class="grey--text font-description">Ime i prezime / Name and surname</div>

        <!--        <div class="font-weight-medium font-title mt-6">-->
        <!--          {{ card.user.uid }}-->
        <!--        </div>-->
        <!--        <div class="grey&#45;&#45;text font-description">eduID</div>-->

        <!--        <div class="container-img">-->
        <template v-if="card.status > -1">
          <img v-if="card.qr_code" @click="dialog_qr=true" class="hidden-sm-and-up img-qrcode mt-4"
               style="cursor: pointer" :src="card.qr_code.file_url"/>
          <v-icon v-if="card.qr_code" class="mb-n1 ml-n4" color="red">mdi-arrow-expand</v-icon>
        </template>
        <template v-else>
          <v-icon size="100" color="red" class="mt-3 ml-6">mdi-close-circle</v-icon>
        </template>
        <!--          <div class="middle" v-if="isHovered">-->
        <!--            <v-icon color="black" class="pt-5" size="50">mdi-home</v-icon>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
    <!--    <v-img class="mt-6 hidden-sm-and-up" height="100" contain :src="card.qr_code.file_url"></v-img>-->
    <v-container :class="$vuetify.breakpoint.xs == true ? '': 'login-bg'"
                 :style="$vuetify.breakpoint.xs == true ? '': {'background-image': 'url(' + require('@/assets/background.png') + ')'}"
                 class="fill-height" fluid>
      <v-row align="start" :class="$vuetify.breakpoint.smAndDown == true ? 'pt-0 fill-height' : 'fill-height'">
        <v-col cols="12" sm="4" md="3" style="height: 100%" class="hidden-sm-and-down">
          <v-card class="card-bg pa-8 card-outter"
                  :style="{'background-image': 'url(' + require('@/assets/background-card.png') + ')'}" flat
                  color="sum" rounded="xl" style="height: 100% !important;">
            <a href="https://sum.ba" target="_blank">
              <img height="80" :src="require('@/assets/sum-white.svg')" style="border-radius: 0px"/>
            </a>
            <v-row class="mt-6">
              <v-col cols="1">
                <div style="border-left: 4px solid white; height: 100%"></div>
              </v-col>
              <v-col xols="12">
                <div class="text-uppercase white--text font-weight-medium">Sveučilišna iskaznica</div>
                <div class="text-uppercase white--text font-weight-light">University identity card</div>

                <div class="white--text font-weight-medium mt-6" style="font-size: 12px">Sveučilište u Mostaru</div>
                <div class="white--text font-weight-light" style="font-size: 12px">University of Mostar</div>
              </v-col>
            </v-row>
            <!--            <v-card-actions class="card-actions">-->
            <div class="mr-7" style="position: absolute; bottom: 25px">
              <v-row class="mt-6">
                <v-col cols="1">
                  <div style="border-left: 4px solid white; height: 100%"></div>
                </v-col>
                <v-col xols="12">
                  <div class="white--text font-weight-light" style="font-size: 10px">
                    Ova iskaznica je vlasništvo Sveučilišta u Mostaru. Iskaznicu može koristiti samo osoba na čije ime
                    glasi. Za više informacija pogledajte issi.sum.ba
                  </div>
                  <div class="white--text font-weight-light mt-2" style="font-size: 10px">
                    This identification card is the property of the University of Mostar. It can only be used by the
                    person it was assigned to. For more information, visit issi.sum.ba
                  </div>
                </v-col>
              </v-row>
            </div>
            <!--            </v-card-actions>-->
          </v-card>
        </v-col>
        <v-col cols="12" sm="8" md="9" :class="$vuetify.breakpoint.smAndDown == true ? 'pt-0' : 'mt-2'">
          <v-app-bar color="transparent" flat class="hidden-sm-and-down">
            <div>
              <div class="sum--text" style="text-transform:capitalize; font-size: 18px">
                {{ moment(today).format("dddd, D.M.YYYY.") }}
              </div>
              <div class="sum--text" style="font-size: 28px">{{ moment(today).format("HH:mm:ss") }}</div>
            </div>
            <v-spacer></v-spacer>
            <div class="sum--text">
              <v-icon size="22" color="green" v-if="card.status > -1">mdi-check-circle</v-icon>
              <v-icon size="22" color="red" v-else>mdi-close-circle-outline</v-icon>
              Aktivnost

              <v-icon @click="dialog_status = true" style="cursor: pointer" size="22" color="#828282" class="ml-2">mdi-information-outline</v-icon>
            </div>
<!--            <div class="sum&#45;&#45;text ml-12">-->
<!--              <v-icon size="26" color="sum">mdi-flag-outline</v-icon>-->
<!--              HR-->
<!--            </div>-->
          </v-app-bar>
          <v-container :class="$vuetify.breakpoint.smAndDown == true ? 'pt-0' : ''">
            <v-row v-if="card.user">
              <v-col cols="12" md="3" class="hidden-sm-and-down">
                <v-img v-if="card.user" style="border-radius: 15px" :src="card.user.avatar_url"></v-img>
                <!--                <v-img style="border-radius: 15px" src="/img/rektor.jpeg"></v-img>-->
                <v-btn v-if="card.user.affiliation !== 'student'" color="sum" class="text-none mt-6" dark width="100%"
                       @click="openCV()">
                  <v-icon left>mdi-file-account-outline</v-icon>
                  CV
                </v-btn>
                <v-btn v-else-if="card.status === 3" color="sum" text class="text-none mt-6" dark width="100%"
                       :href="'http://esc.gg/' + card.uuid" target="_blank" style="border: 1px solid #acacac">
                  <img height="22" class="mr-4" :src="require('@/assets/logo_esc.png')"/>ESC
                </v-btn>
                <v-btn class="text-none mt-2" text color="sum" block style="border: 1px solid #acacac" @click="addToContacts">
                  <v-icon left>mdi-account-plus-outline</v-icon>
                  Dodaj u kontakte
                </v-btn>
                <!--qr će biti na frontu - generiranje-->
                <template v-if="card.status > -1">
                  <v-img v-if="card.qr_code" @click="dialog_qr = true" style="cursor: pointer" class="mt-4" height="100" contain :src="card.qr_code.file_url"></v-img>
                </template>
                <template v-else>
                  <v-icon size="100" color="red" class="mt-6 ml-12">mdi-close-circle</v-icon>
                </template>

              </v-col>
              <v-col cols="12" md="3" class="hidden-sm-and-up">
                <v-row class="aktivnost-bg " align="center">
                  <v-col cols="10">
                    <span class="sum--text" style="font-size: 24px">Aktivnost</span>
                    <v-icon v-if="card.status > 0" class="ml-2" style="margin-top: -7px" size="28" color="green">
                      mdi-check-circle
                    </v-icon>
                    <v-icon v-else class="ml-2" style="margin-top: -7px" size="28" color="red">
                      mdi-close-circle-outline
                    </v-icon>
                  </v-col>
                  <v-col cols="2">
                    <v-icon @click="dialog_status = true" style="cursor: pointer" size="28" color="#828282">mdi-information-outline</v-icon>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="3" :class="$vuetify.breakpoint.xsOnly ? 'pb-0' : ''">
                <div v-if="$vuetify.breakpoint.smAndUp" class="font-weight-medium font-title">
                  {{ card.user.first_name + ' ' + card.user.last_name }}
                </div>
                <div v-if="$vuetify.breakpoint.smAndUp" class="grey--text font-description mb-6">Ime i prezime / Name
                  and
                  surname
                </div>

                <div class="font-weight-medium font-title">{{ card.user.organization_unit.name }}</div>
                <div class="grey--text font-description mb-6">Fakultet / Faculty</div>

                <div class="font-weight-medium font-title">{{ card.user.sib }}</div>
                <div class="grey--text font-description mb-6">Sveučilišni ID broj / University ID number</div>

                <div class="font-weight-medium font-title" v-if="card.number">{{ card.number }}</div>
                <div class="grey--text font-description mb-6" v-if="card.number">Broj iskaznice / ID Card number</div>

                <div class="font-weight-medium font-title" v-if="card.user.affiliation !== 'student'">
                  {{ card.user.uid }}
                </div>
                <div class="grey--text font-description mb-6" v-if="card.user.affiliation !== 'student'">eduID</div>
              </v-col >
              <v-col cols="12" md="3" :class="$vuetify.breakpoint.xsOnly ? 'pt-0' : ''">
                <div class="font-weight-medium font-title" v-if="card.user.affiliation === 'student'">{{
                    card.user.uid
                  }}
                </div>
                <div class="grey--text font-description mb-6" v-if="card.user.affiliation === 'student'">eduID</div>

                <div class="font-weight-medium font-title" v-if="card.user.professional_status !== '---' && card.user.professional_status !== null">
                  {{ card.user.professional_status }}
                </div>
                <div class="grey--text font-description mb-6" v-if="card.user.professional_status !== '---' && card.user.professional_status !== null">Akademski
                  stupanj / Academic degree
                </div>

                <div class="font-weight-medium font-title" v-if="card.user.academic_status !== '---' && card.user.academic_status !== null">
                  {{ card.user.academic_status }}
                </div>
                <div class="grey--text font-description mb-6" v-if="card.user.academic_status  !== '---' && card.user.academic_status !== null">Akademsko
                  zvanje / Academic title
                </div>

                <div class="font-weight-medium font-title">{{
                    moment(card.user.date_of_birth).format("D.M.YYYY.")
                  }}
                </div>
                <div class="grey--text font-description mb-6">Datum rođenja / Date of birth</div>

                <div v-if="card.status === 3" class="font-weight-medium font-title">
                  <span v-if="card.card_batch">{{ moment(card.card_batch.issue_date).format("D.M.YYYY.") }}</span>
                  <span v-else>---</span>
                </div>
                <div v-if="card.status === 3" class="grey--text font-description mb-6">Datum izdavanja / Date of issue</div>

                <div v-if="card.user.affiliation" class="font-weight-medium font-title text-capitalize">{{ card.user.affiliation }}</div>
                <div v-if="card.user.affiliation" class="grey--text font-description mb-6">Povezanost s ustanovom / Institution affiliation</div>
              </v-col>
              <v-col cols="12" class="hidden-sm-and-up">
                <v-btn v-if="card.user.affiliation !== 'student'" color="sum" class="text-none" dark width="100%"
                       @click="openCV()">
                  <v-icon left>mdi-file-account-outline</v-icon>
                  CV
                </v-btn>
                <v-btn v-else-if="card.status === 3" color="sum" text class="text-none" dark width="100%"
                       :href="'http://esc.gg/' + card.uuid" target="_blank" style="border: 1px solid #c3c3c3">
                  <img height="22" class="mr-4" :src="require('@/assets/logo_esc.png')"/>ESC
                </v-btn>
              </v-col>
              <v-col cols="12" class="hidden-sm-and-up">
                <v-btn class="text-none" text color="sum" block style="border: 1px solid #c3c3c3" @click="addToContacts">
                  <v-icon left>mdi-account-plus-outline</v-icon>
                  Dodaj u kontakte
                </v-btn>
              </v-col>
              <v-col cols="12" md="3"></v-col>
            </v-row>
            <!--            <div style="position: absolute; bottom: 40px; right: 60px">-->
            <!--              <v-btn class="text-none" height="30px" width="150px" color="#d4d4d4" elevation="0">Odjava</v-btn>-->
            <!--            </div>-->
            <span class="grey--text hidden-sm-and-down"
                  style="position: absolute; bottom: 25px; right: 25px; font-size: 12px">Copyright ©{{
                new Date().getFullYear()
              }} SUMIT</span>
            <div class="grey--text hidden-md-and-up text-center" style="font-size: 12px">Copyright
              ©{{ new Date().getFullYear() }} SUMIT
            </div>
          </v-container>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
        transition="dialog-top-transition"
        max-width="500"
        v-model="dialog_status"
    >
      <v-card>
        <v-card-text class="pt-5 text-center">
          <v-icon v-if="card.status > 0" class="mb-2" style="" size="35" color="green">
            mdi-check-circle
          </v-icon>
          <v-icon v-else class="mb-2" style="" size="35" color="red">
            mdi-close-circle-outline
          </v-icon>
          <p class="sum--text" style="font-size: 24px" v-if="card.status > 0">Aktivan</p>
          <p class="sum--text" style="font-size: 24px" v-else>Neaktivan</p>

          <div class="body-1" v-if="card.user">
            Kartica aktivna do:
            <span v-if="card.user.expire_date !== null">{{ moment(card.user.expire_date).format('DD.MM.YYYY') }}</span>
            <span v-else>Neodređeno</span>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
              text
              @click="dialog_status = false"
          >Zatvori
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        transition="dialog-top-transition"
        max-width="500"
        v-model="dialog_qr"
    >
      <v-card>
        <v-card-text class="pt-5">
          <v-img v-if="card.qr_code" :src="card.qr_code.file_url"/>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
              text
              @click="dialog_qr = false"
          >Zatvori
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "CardsPreview",
  components: {},
  created() {
    this.updateDateTime()
    // console.log(this.$route.params.card_num)
    this.getUser()
  },
  mounted() {
  },
  methods: {
    async getUser() {
      this.$axios({
        method: 'GET',
        url: `university_cards/uuid/${this.$route.params.card_num}`,
      }).then((response) => {
        this.card = response.data
        // console.log(response)
      })
          .catch(function (er) {
            console.log(er)
            // $nuxt.$emit('show-snackbar', false)
          })
      // let data = await this.$axios.get("https://api.sum.ba/sso/user");
    },

    openCV() {
      window.open('https://cv.sum.ba/' + this.card.user.uid, '_blank')
    },

    addToContacts() {
      window.open(`https://api.eduid.sum.ba/users/${this.card.user.uid}/vcard`)
    },

    updateDateTime() {
      this.getDateTime()
      setInterval(() => {
        this.getDateTime()
      }, 1000)
    },

    getDateTime() {
      this.today = new Date()
    },
  },
  data() {
    return {
      today: null,
      card: {},
      dialog_qr: false,
      dialog_status: false,
      isHovered: false,
    }
  }
}
</script>

<style scoped>
.login-bg {
  /*background-image: url(require('./assets/background.png'));*/
  background-size: cover;
  background-color: #E5E5E5;
  max-height: 100%;
}

.card-bg {
  /*background-image: url('/img/background-card.png');*/
  background-size: cover;
  max-height: 100%;
}

.font-title {
  font-size: 23px;
}

.font-description {
  font-size: 14px;
}

.bg-color {
  background-color: #084776;
  height: 150px;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
}

.img-radius {
  //width: 100%;
  height: 200px;
  //margin-top: -15px;
  border-radius: 25px;
}

.img-qrcode {
  //width: 100%;
  height: 110px;
}

.aktivnost-bg {
  border-radius: 10px;
  background-color: #F2F2F2;
}

.container-img {
  position: relative;
  width: 50%;
  cursor: pointer;
}

.image-qr {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: .5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.container-img:hover .image-qr {
  opacity: 0.3;
}

.container-img:hover .middle {
  opacity: 1;
}

/*.card-outter {*/
/*  position: relative;*/
/*  padding-bottom: 50px;*/
/*}*/
/*.card-actions {*/
/*  position: absolute;*/
/*  bottom: 0;*/
/*}*/
</style>